import { render, staticRenderFns } from "./PrefixDetails.vue?vue&type=template&id=5cee2984&scoped=true&"
import script from "./PrefixDetails.vue?vue&type=script&lang=js&"
export * from "./PrefixDetails.vue?vue&type=script&lang=js&"
import style0 from "./PrefixDetails.vue?vue&type=style&index=0&id=5cee2984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cee2984",
  null
  
)

export default component.exports